import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CENProductFinePrintText from "@tCentro/Components/CENProductFinePrintText";
import * as React from "react";

type Props = WidgetProps & HasProduct;

const CENProductFinitePrintText: React.FC<Props> = ({ product }) => {
    if (!product?.properties) {
        return null;
    }

    return (
        <StyledWrapper>
            {product.properties.finePrint && <CENProductFinePrintText finePrint={product.properties.finePrint} />}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(CENProductFinitePrintText),
    definition: {
        displayName: "CEN Product Fine Print Text",
        group: "Product Details",
    },
};

export default widgetModule;
